<template>
  <b-modal
    id="edit-entries"
    ref="edit-entries"
    size="edit-entries"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get("select_entries_to_edit") }}
      </h2>
    </div>
    <div ref="scrollHeight" class="content-wrapper">
      <perfect-scrollbar>
        <div v-for="(entry, idx) in entries" :key="entry.id" class="field-row">
          <div class="field-details">
            <b-form-radio
              name="some-radios"
              :value="entry"
              @change="changedEntry"
            >
              Entry {{ idx + 1 }}
            </b-form-radio>
            <div class="time-interval">
              <span class="start-time">
                {{ entry.start_time }}
              </span>
              <i class="atto atto-rdir-arrow-b" />
              <span class="end-time">
                {{ entry.end_time }}
              </span>
            </div>
            <!--<button class="delete-entry">-->
            <!--<i class="atto atto-delete"></i>-->
            <!--</button>-->
          </div>
        </div>
      </perfect-scrollbar>
    </div>

    <div class="modal-footer">
      <button type="reset" class="atto-btn cancel" @click="close">
        {{ label.get("cancel") }}
      </button>
      <button type="submit" class="atto-btn submit" @click="editEntry">
        {{ label.get("select_entry") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "EditEntriesComponent",
  props: {
    entries: {
      type: Array,
      default: () => {
        return [];
      },
    },
    member: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      selectedEntry: null,
    };
  },
  mounted() {
    this.$refs["edit-entries"].show();

    //this.maxHeight();
  },
  methods: {
    changedEntry(entry) {
      this.selectedEntry = entry;
    },
    editEntry() {
      if (this.selectedEntry === null) {
        return;
      }
      this.$root.$emit("hideEditEntries", {
        entry: this.selectedEntry,
        member: this.member,
      });
    },
    close() {
      this.$root.$emit("hideEditEntries");
    },

    /*maxHeight(){
                let height = this.$refs.scrollHeight.offsetHeight + 'px' - 300;
                Vue.set(this.scrollStyle, 'height', height);

                console.log(height);
            }*/
  },
};
</script>

<style lang="scss">
.modal-edit-entries {
  max-width: 480px;
  max-height: 448px;
  .modal-body {
    padding: 0;

    .content-wrapper {
      padding: 42px 48px 44px;
      height: auto;
    }
  }
  .modal-head {
    padding: 46px 48px 0;
    display: flex;

    .modal-title {
      font-size: 1.25rem;
      line-height: 1.75rem;
      font-family: "Roboto", sans-serif;
      font-weight: 700;
      color: #262626;
    }
  }

  .time-interval {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    width: 184px;
    align-items: center;
    .start-time,
    .end-time {
      min-width: 80px;
      max-width: 80px;
      padding: 8px;
      background-color: #f7f7f7;
      text-align: center;
      display: inline-block;

      /* Font Styles */
      font-size: 0.875rem;
      line-height: 1.5rem;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      color: #262626;
    }
    i {
      font-size: 9px;
      width: 24px;
      height: 24px;
      color: #c7c7c7;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .modal-footer {
    padding: 2px 48px 48px;
    .atto-btn {
      width: 50%;
    }
  }
}

button.delete-entry {
  margin: 0;
  padding: 0;
  margin-left: 24px;
  i {
    font-size: 24px;
    color: #efefef;
  }
}

.field-details {
  width: 100%;
  margin-bottom: 12px;
  .custom-control {
    align-items: center;
    padding-left: 32px;
    &:hover {
      cursor: pointer;
    }
  }

  .custom-control-label {
    display: inline-flex;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    color: #262626;

    &:before {
      width: 24px;
      height: 24px;
      top: 0;
      left: -32px;
      background-color: transparent;
      border: 1.5px solid #c7c7c7;
      &:hover {
        cursor: pointer;
      }
    }

    &:after {
      width: 12px;
      height: 12px;
      border-radius: 12px;
      left: -26px;
      top: 6px;
      background-color: transparent;
      background-image: none;
    }
  }
  .custom-radio {
    .custom-control-input:checked {
      ~ .custom-control-label {
        &::before {
          border-color: #00b9cb;
          background-color: transparent;
        }

        &::after {
          width: 12px;
          height: 12px;
          border-radius: 12px;
          left: -26px;
          top: 6px;
          background-color: #00b9cb;
          background-image: none;
        }
      }
    }
    .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: none;
    }
  }
}

.field-row {
  display: flex;
  flex-direction: row;
  .field-details {
    display: flex;
    flex-direction: row;
  }
  &:last-child {
    .field-details {
      margin-bottom: 0;
    }
  }
}
</style>
